import React from 'react';
import { PageLeadMessagesModeProvider } from 'src/pages/landlord/leads/messages/context/mode';
import LeadMessagesSurface from 'src/pages/landlord/leads/messages/LeadMessagesSurface';

export default function LeadMessagesPage() {
    return (
        <PageLeadMessagesModeProvider>
            <LeadMessagesSurface />
        </PageLeadMessagesModeProvider>
    );
}
